import React from 'react';
import aboutImg from '../../images/about-us.png';
import beach from '../../images/beach.png';
import '../../styles/about.css';

const chooseData = [
    {
        icon: 'ri-wifi-line',
        title: 'At SmartSen',
        desc: 'we strengthen defenses against terrorist threats by incorporating innovative technology that enables solutions previously thought unattainable.'
    },
    {
        icon: 'ri-team-line',
        title: 'Our focus encompasses DOAP',
        desc: 'Detection of small <b>Objects</b> <b>Approaching</b> in <b>Public</b> spaces, such as small engines in cardboard drones.',
    },
];

export default function About() {
    return (
      <section id="about">
          <div className="container">
              <div className="about_wrapper">
                  <div className="about_content">
                      <h2 className="subtitle fade-in">About Q-MAG</h2>
                      <h4 className='subtitle_two fade-in-delay'>Quantum Magnetic Anomaly Gradiometer sensor (Q-MAG)</h4>
                      <p className="fade-in-delay-2">The Q-MAG diagnoses tiny variations in the Earth's natural magnetic field influenced by any small threat being scanned or approaching A breakthrough solution that outperforms conventional MAD (Magnetic Anomaly Detector) with ultra-high sensitivity and stable performance, even amid environmental noise and rapidly changing influences in air, sea, or land</p>
                      <div className="choose_item-wrapper">
                          {chooseData.map((item, index) => (
                              <div className="choose_us-item slide-in" key={index} style={{ animationDelay: `${0.3 + index * 0.2}s` }}>
                                  <span className="choose_us-icon">
                                      <i className={item.icon} />
                                  </span>
                                  <div className="choose_us-content">
                                      <h4
                                        className="choose_us-title"
                                        dangerouslySetInnerHTML={{
                                          __html: item.title.replace(
                                            /\b(DOAP)\b/g,
                                            '<b>$1</b>'
                                          ),
                                        }}
                                      />
                                      <p
                                        className="description"
                                        dangerouslySetInnerHTML={{
                                          __html: item.desc.replace(
                                            /\b(DOAP|Detection|Objects|Approaching|Public)\b/g,
                                            '<b>$1</b>'
                                          ),
                                        }}
                                      />
                                  </div>
                              </div>
                          ))}
                      </div>
                      <div className="beach-icon-wrapper">
                          <img src={beach} alt="beach" className="beach-image" />
                      </div>

                  </div>
                  <div className="about_img">
                      <div className="image-container">
                          <img src={aboutImg} alt="About" className="main-about-image" />
                          <div className="image-overlay"></div>
                      </div>
                      <p className="image-caption">Iran has unveiled its unmanned fighter jet, the Kahr F-313, designed to evade radar detection. "It's similar to drones with bodies made using 3D printers and engines sourced from AliExpress."</p>
                  </div>
              </div>
          </div>
      </section>
    );
}